import {
  IPlanOverviewDetail,
  ISubjectSubscription,
  SubscriptionSource,
} from '@models/interfaces/user.interface';
import { COUNTRY_ID_SINGAPORE } from '@utils/constants/countries.constants';
import moment from 'moment';
import { DetailUser } from '@models/types/users.type';
import {
  GBHE_TRIAL_ID,
  SIGN_UP_TRIAL_ID,
} from '@components/subscription/helper/SubscriptionConstant';

const trialCanSelfServeIds = [GBHE_TRIAL_ID, SIGN_UP_TRIAL_ID];

export function canProceedToSelfServePayment(
  subs: ISubjectSubscription,
  planDetail: IPlanOverviewDetail,
  userDetail: DetailUser,
) {
  if (
    parseInt(userDetail?.country_id) != COUNTRY_ID_SINGAPORE ||
    planDetail.country_id != COUNTRY_ID_SINGAPORE
  ) {
    return false;
  }
  if (subs.is_trial_plan) {
    if (
      trialCanSelfServeIds.findIndex(
        item => item == subs.subscription_plan_id,
      ) == -1
    ) {
      return false;
    }
  }

  return true;
}

export function getRenewalDate(
  subscription: ISubjectSubscription,
  planDetail: IPlanOverviewDetail,
) {
  return moment(
    (planDetail.subscription_source == SubscriptionSource.web
      ? planDetail.recurring.recurring_date
      : subscription.expiry_date) + '+08:00',
  );
}

export function getRenewalPrice(
  subscription: ISubjectSubscription,
  planDetail: IPlanOverviewDetail,
) {
  return moneyFormatter(
    planDetail.currency_code,
    Number(
      planDetail.subscription_source == SubscriptionSource.web
        ? planDetail.recurring.recurring_amount!
        : subscription.amount,
    ),
  );
}

export function moneyFormatter(currency: string, amount: number) {
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  return moneyFormatter.format(amount);
}
